/**
 * Full note-text normalization applied when a note is created or saved.
 *
 * Pipeline:
 * 1. Re-case an all-caps note to sentence form (no-op for normal notes).
 * 2. Expand ADS abbreviations.
 * 3. Capitalize the first word of every sentence. This applies basic sentence
 *    structure and, importantly, re-capitalizes any sentence-leading
 *    abbreviation that step 2 expanded to lowercase (e.g. "MX ..." -> "maintenance ..."
 *    -> "Maintenance ...").
 */
import { expandAbbreviations } from './expandAbbreviations';
import { normalizeNoteCasing, capitalizeSentenceStarts } from './normalizeNoteCasing';

export function processNoteText(text: string): string {
  const expanded = expandAbbreviations(normalizeNoteCasing(text));
  return capitalizeSentenceStarts(expanded);
}
